import NotificationTitle from './NotificationTitle'

export default NotificationTitle
